export default function AtcFlightsListController(
    $scope,
    $controller,
    atcFlightsFactory
) {
    'ngInject';

    $controller('atcFlightsListBaseController', {
        $scope,
        atcFlightsFactory,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/controllers/atcFlightsListController.js